import type BABYLON from 'babylonjs';

import type { Globals } from './globals';
import { loggerError } from './logger';

export interface ImportMeshAsyncOptions {
  name?: string | null;
  rootUrl?: string;
  onProgress?: Parameters<typeof BABYLON.SceneLoader.ImportMeshAsync>[4];
  pluginExtension?: Parameters<typeof BABYLON.SceneLoader.ImportMeshAsync>[5];
}

export async function importMeshAsync(
  globals: Globals,
  container: BABYLON.AssetContainer,
  urlOrFile: string | File,
  { name = null, rootUrl, onProgress, pluginExtension }: ImportMeshAsyncOptions = {}
): Promise<void> {
  let meshRootUrl: string;
  let meshFilename: string | File;
  if (urlOrFile instanceof File) {
    meshRootUrl = rootUrl || '';
    meshFilename = urlOrFile;
  } else {
    meshRootUrl = rootUrl != null ? rootUrl : urlOrFile.replace(/[/]+$/, '');
    if (!urlOrFile.startsWith(meshRootUrl)) {
      throw new Error(`URL ${urlOrFile} is not included in Root URL ${meshRootUrl}`);
    }
    meshFilename = urlOrFile.slice(meshRootUrl.length);
  }
  try {
    const result = await globals.BABYLON.SceneLoader.ImportMeshAsync(
      name,
      meshRootUrl,
      meshFilename,
      undefined,
      onProgress,
      pluginExtension
    );
    container.meshes.push(...result.meshes);
  } catch (err) {
    loggerError(globals, err);
    throw err;
  }
}
